<template>
  <div></div>
</template>

<script>
  export default {
    name: 'BreakpointWatcher',
    watch: {
      '$vuetify.breakpoint.smAndDown'(isMobile) {
        if (isMobile && !this.$route.path.startsWith('/mobile')) {
          this.$router.push('/mobile');
        } else if (!isMobile && this.$route.path.startsWith('/mobile')) {
          this.$router.push('/');
        }
      }
    },
    mounted() {
      const isMobile = this.$vuetify.breakpoint.smAndDown;
      if (isMobile && !this.$route.path.startsWith('/mobile')) {
        this.$router.push('/mobile');
      } else if (!isMobile && this.$route.path.startsWith('/mobile')) {
        this.$router.push('/');
      }
    }
  };
</script>
